import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import { labelSty, styInput } from "./styles-input";
import { SelectChangeEvent } from "@mui/material";

interface SelectMultipleInputPropsType {
  label: string;
  value: any;
  disabled: boolean;
  onChange: (event: SelectChangeEvent<any>) => void;
  options: { value: any; label: string }[];
}
export default function SelectInputMultiple({
  label,
  value,
  disabled,
  onChange,
  options,
}: SelectMultipleInputPropsType) {
  const theme = useTheme();
  return (
    <Box sx={{ my: 2, width: "100%" }}>
      <InputLabel
        sx={{
          ...labelSty,
          color: theme.palette.common.black,
        }}
      >
        {label}
      </InputLabel>
      <FormControl sx={{ m: 1, width: "100%" }}>
        <Select
          value={value ?? ""}
          onChange={onChange}
          multiple
          sx={{ width: "100%", ...styInput }}
        >
          {options?.map((val, id) => (
            <MenuItem key={id} value={val.value} disabled={disabled}>
              {val.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}



export const MultiSelectBenefits = ({benefits, handleBenefits}) => {
 

  const benefitOptions = [
    { value: "No benefits", label: "No benefits" },
    { value: "Health insurance", label: "Health insurance" },
    { value: "Commuting benefits", label: "Commuting benefits" },
    { value: "Accommodation", label: "Accommodation" },
    { value: "Paid leave", label: "Paid leave" },
    { value: "Family care", label: "Family care" },
    { value: "Retirement benefit", label: "Retirement benefit" }
  ];

  return (
    <Select
      multiple
      value={benefits}
      onChange={handleBenefits}
      renderValue={(selected) => selected.join(', ')}
      sx={{ width: "100%", ...styInput }}
    >
      {benefitOptions.map((option) => (
        <MenuItem 
          key={option.value} 
          value={option.value}
          disabled={benefits.includes("No benefits") && option.value !== "No benefits"}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

